import { render, staticRenderFns } from "./icon-checkbox-check.vue?vue&type=template&id=18c031e3"
import script from "./icon-checkbox-check.vue?vue&type=script&lang=js"
export * from "./icon-checkbox-check.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@5.2.7_webpack@4.47.0___3aa45358577dd566fcc66441f4bfb966/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/opt/atlassian/pipelines/agent/build/components/icons/icon.vue').default})
